import { Button, Form, Image, Modal } from "react-bootstrap";
import { FaTimesCircle } from "react-icons/fa";

const EditPartnerModal = ({
  show,
  onHide,
  isEdit = false,
  form,
  setForm,
  onExited,
  clearFieldError,
  fieldErrors,
  savePartner,
  onClose,
  buildLogoUrl,
}) => {
  // remove logo helper
  const removeLogo = () => {
    setForm({ ...form, logo: undefined, logoPreview: undefined });
  };

  return (
    <Modal show={show} onHide={onHide} onExited={onExited} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>{isEdit ? "Edit Partner" : "Add Partner"}</Modal.Title>
      </Modal.Header>

      <Form onSubmit={savePartner}>
        <Modal.Body>
          <div className="d-grid columns-3 gap-3">
            {/* Logo Upload + Preview */}
            <Form.Group
              className="d-grid columns-2 gap-3 span-3"
              style={{ height: "80px" }}
              controlId="partner-logo"
            >
              <div>
                <Form.Label>Logo</Form.Label>
                <Form.Control
                  type="file"
                  accept="image/*"
                  onChange={(e) => {
                    const file = e.target.files?.[0];
                    if (file) {
                      const url = URL.createObjectURL(file);
                      setForm({ ...form, logo: file, logoPreview: url });
                      clearFieldError("logo");
                    }
                  }}
                />
              </div>

              {/* Show Preview */}
              {(form.logoPreview || form.logo) && (
                <figure
                  className="position-relative d-flex align-items-center justify-content-center m-0 h-100"
                  style={{ width: "120px" }}
                >
                  <Image
                    src={
                      form.logoPreview
                        ? form.logoPreview
                        : buildLogoUrl(form.logo)
                    }
                    alt="Preview"
                    style={{ height: "80px", objectFit: "contain" }}
                    fluid
                    className="rounded-2"
                  />

                  {/* Cross Button inside image corner */}
                  <FaTimesCircle
                    onClick={removeLogo}
                    style={{
                      position: "absolute",
                      top: "-8px",
                      right: "-8px",
                      cursor: "pointer",
                      color: "#bf352b",
                      fontSize: "20px",
                    }}
                  />
                </figure>
              )}
            </Form.Group>

            {/* Partner Code */}
            <Form.Group controlId="partner-code">
              <Form.Label>Partner Code*</Form.Label>
              <Form.Control
                value={form.partner_code}
                onChange={(e) => {
                  const v = e.target.value.toUpperCase();
                  setForm({ ...form, partner_code: v });
                  clearFieldError("partner_code");
                }}
                disabled={!!isEdit}
                isInvalid={!!fieldErrors.partner_code}
              />
              <Form.Control.Feedback type="invalid">
                {fieldErrors.partner_code}
              </Form.Control.Feedback>
            </Form.Group>

            {/* Name */}
            <Form.Group controlId="partner-name">
              <Form.Label>Name*</Form.Label>
              <Form.Control
                value={form.name}
                onChange={(e) => {
                  setForm({ ...form, name: e.target.value });
                  clearFieldError("name");
                }}
                isInvalid={!!fieldErrors.name}
              />
              <Form.Control.Feedback type="invalid">
                {fieldErrors.name}
              </Form.Control.Feedback>
            </Form.Group>

            {/* Company Name */}
            <Form.Group controlId="company-name">
              <Form.Label>Company Name</Form.Label>
              <Form.Control
                value={form.company_name}
                onChange={(e) =>
                  setForm({ ...form, company_name: e.target.value })
                }
              />
            </Form.Group>

            {/* Email */}
            <Form.Group controlId="partner-email">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                value={form.email}
                onChange={(e) => {
                  setForm({ ...form, email: e.target.value.trim() });
                  clearFieldError("email");
                }}
                isInvalid={!!fieldErrors.email}
              />
              <Form.Control.Feedback type="invalid">
                {fieldErrors.email}
              </Form.Control.Feedback>
            </Form.Group>

            {/* Mobile Number */}
            <Form.Group controlId="partner-mobile">
              <Form.Label>Mobile Number</Form.Label>
              <Form.Control
                value={form.mobile_number}
                onChange={(e) => {
                  setForm({ ...form, mobile_number: e.target.value });
                  clearFieldError("mobile_number");
                }}
                isInvalid={!!fieldErrors.mobile_number}
              />
              <Form.Control.Feedback type="invalid">
                {fieldErrors.mobile_number}
              </Form.Control.Feedback>
            </Form.Group>

            {/* ARN/AFMI */}
            <Form.Group controlId="arn/afmi">
              <Form.Label>ARN/AFMI No</Form.Label>
              <Form.Control
                value={form.arn_afmi_no}
                onChange={(e) =>
                  setForm({ ...form, arn_afmi_no: e.target.value })
                }
              />
            </Form.Group>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="primary" type="submit">
            {isEdit ? "Update" : "Create"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default EditPartnerModal;
